import React, {useContext, useEffect, useState} from 'react';
import {injectIntl} from "react-intl";
import SelectField from "@FormElements/SelectField";
import Logger from "@ffw/logger-lib";
import {useRouteMatch} from "react-router-dom";
import axios from 'axios';
import FormContext from "formContext";
import MultipleCheckboxes from "@FormElements/MultipleCheckboxes";

function SpecialismSelectFields({intl, settings, ...rest}) {
  const {onChange} = rest;
  const route = useRouteMatch();

  const {currentStep, setFormData} = useContext(FormContext);
  const [specialismsData, setSpecialismsData] = useState(false);

  useEffect( () => {
    async function fetchData() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_PREFIX}/specialisms-hierarchy`);
        setSpecialismsData(res.data);
      } catch (err) {
        Logger.error(err);
      }
    }
    fetchData();
  }, []);

  let job_categories = specialismsData.job_categories;
  let positions = specialismsData.positions;
  let experiences = specialismsData.experiences;

  const SpecialismField = () => {
    if (!job_categories || !Object.keys(job_categories).length) {
      return null;
    }
    const specialismOptions = [];
    specialismOptions.push({ value: "", label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'}) });

    for (const property in job_categories) {
      specialismOptions.push({
        value: property,
        label: job_categories[property],
      });
    }

    settings.options = specialismOptions;
    let specialism = settings.state ? settings.state.specialism : '';
    return (
      <SelectField
        settings={{...settings}}
        {...rest}
        value={specialism}
        onChange={handleSpecialismChange}
      />
    )
  };

  const handleSpecialismChange = event => {
    if (settings && settings.subspecialism && settings.subspecialism.name) {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        const subSpecialismName = settings.subspecialism.name;
        prev[currentStep][subSpecialismName] = '';
        prev[currentStep]['specialism_id'] = '';
        prev[currentStep]['sub_specialism_id'] = '';
        return {
          ...prev
        }
      });
    }
    onChange(event);
  };

  const SubSpecialismField = () => {
    if (!job_categories || !Object.keys(job_categories).length
      || !positions || !Object.keys(positions).length
      || !settings.state) {
      return null;
    }

    const subSpecialismOptions = [];

    let currentSpec;
    for (const property in job_categories) {
      if (property === settings.state.specialism) {
        currentSpec = property;
        break;
      }
    }

    let currentPositions;
    for (const property in positions) {
      if (property === currentSpec) {
        currentPositions = positions[property];
        break;
      }
    }

    if (!currentPositions || !Object.keys(currentPositions).length) {
      return null;
    }

    subSpecialismOptions.push({ value: "", label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'}) });
    for (const property in currentPositions) {
      subSpecialismOptions.push({
        value: property,
        label: currentPositions[property],
      });
    }

    if (!subSpecialismOptions.length) {
      return '';
    }
    settings.subspecialism.options = subSpecialismOptions;
    let sub_specialism = settings.state ? settings.state.sub_specialism : '';
    return (
      <SelectField
        settings={{...settings, ...settings.subspecialism, required: true}}
        {...rest}
        value={sub_specialism}
      />
    )
  };

  const ExperienceField = () => {
    if (!job_categories || !Object.keys(job_categories).length
      || !positions || !Object.keys(positions).length
      || !settings.state || !settings.state.sub_specialism) {
      return null;
    }

    // const experiencesOptions = [];
    let currentSpec;
    for (const property in positions) {
      for (const property2 in positions[property]) {
        if (property2 === settings.state.sub_specialism) {
          currentSpec = property2;
          break;
        }
      }
    }

    let currentExperiences;
    for (const property in experiences) {
      if (property === currentSpec) {
        currentExperiences = experiences[property];
        break;
      }
    }

    if (!currentExperiences || !Object.keys(currentExperiences).length) {
      return null;
    }

    let experiencesArray = [];
    if (settings.state.experiences) {
      if (Object.prototype.toString.call(settings.state.experiences) === '[object Object]') {
        for (const property in settings.state.experiences) {
          experiencesArray.push(settings.state.experiences[property]);
        }
      } else {
        experiencesArray = JSON.parse(settings.state.experiences);
      }
    }

    let checkboxes = [];
    // experiencesOptions.push({ value: "", label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'}) });
    for (const property in currentExperiences) {
      checkboxes.push({
        "name": property,
        'label': currentExperiences[property],
        "isTranslation": true,
        "isChecked": experiencesArray.includes(property)
      });
    }

    if (!checkboxes.length) {
      return '';
    }

    // settings.subspecialism.experience.options = experiencesOptions;
    // settings.subspecialism.experience.valueExperience = valueExperience;
    return (
      <MultipleCheckboxes
        settings={{
          ...settings,
          name: "experiences",
          storeTagsIn: "experiences",
          title: "Register.Section.JobsPreferences.ExperienceLabel",
          currentStep: currentStep,
          checkboxes: checkboxes,
          required: false
        }}
        onChange={onChange}
      />
    )
  }

  return (
    <>
      <SpecialismField />
      <SubSpecialismField />
      <ExperienceField />
    </>
  )
}

export default injectIntl(SpecialismSelectFields);
